export const PLAYER_DOMAIN = 'player.wavve.com'

export const PLAYER_TYPE = {
  LIVE: 'live',
  VOD: 'vod',
  ONAIRVOD: 'onairvod',
  MOVIE: 'movie',
  BASEBALL: 'baseball'
}

export const ATTR_BY_PLAYER_TYPE = {
  live: {
    id: 'channelid',
    title: 'title'
  },
  vod: {
    id: 'contentid',
    title: 'seasontitle'
  },
  onairvod: {
    id: 'contentid',
    title: 'seasontitle'
  },
  movie: {
    id: 'movieid',
    title: 'title'
  },
  baseball: {
    id: 'contentid',
    title: 'title'
  }
}

export const TRAILER_ATTR_BY_PLAYER_TYPE = {
  live: {
    id: 'channelid',
    title: 'title'
  },
  vod: {
    id: 'trailercontentid',
    title: 'seasontitle'
  },
  onairvod: {
    id: 'contentid',
    title: 'seasontitle'
  },
  movie: {
    id: 'movietrailerid',
    title: 'title'
  },
  baseball: {
    id: 'contentid',
    title: 'title'
  }
}
